import React from 'react';
import { GenericNodeView } from 'common/components/PreviewApprovalHierarchyReactFlow/NodeView';
import {
  MessageTravelAuthorizationCreate,
  MessageTravelAuthorizationCreateVariables,
} from 'travelAuthorization/TravelPlan/view/FormView/ActionMenu/Messages/NewMessage/__generated__/MessageTravelAuthorizationCreate';
import { HierarchyNode } from '..';

import ADD_NEW_MESSAGE from '../../../../ActionMenu/Messages/NewMessage/MessageTravelAuthorizationCreate.graphql';

interface NodeViewProps {
  nodeData: HierarchyNode;
}

export const NodeView: React.FC<NodeViewProps> = ({ nodeData }) => (
  <GenericNodeView<
    HierarchyNode,
    MessageTravelAuthorizationCreate,
    MessageTravelAuthorizationCreateVariables
  >
    data={nodeData}
    addNewMessageMutation={ADD_NEW_MESSAGE}
    getEntityId={(data) => data.entityId!}
  />
);
